export const EQ = 'value';
export const NOT = 'not';
export const GT = 'gt';
export const LT = 'lt';
export const GTE = 'gte';
export const LTE = 'lte';
export const COMPARISON_OPERATORS = [EQ, NOT, GT, LT, GTE, LTE];
export const AND = 'and';
export const OR = 'or';
export const LOGIC = [AND, OR];
